/**
 * Custom hook for events data
 */

import { useApi } from './useApi';
import { fetchEventsData } from '@/lib/api/events';

export function useEventsData() {
  return useApi(fetchEventsData, []);
}
